import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {IHTHGameData, IHTHInitData} from "./HTHData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {HTHSymbol, ISymbolData} from "../symbols/HTHSymbol";
import {HTH} from "../HTH";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {HTHGameMode} from "./HTHGameMode";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/utils/server/IData";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {HTHHelper} from "../utils/HTHHelper";
import {HTHGameConfig} from "../HTHGameConfig";
import {HTHAvalancheReelModel} from "../reels/HTHAvalancheReelModel";
import {HTHWinConfig, IBigWinLevel} from "../configs/HTHWinConfig";

export class HTHModel extends GameModel<IHTHInitData, IHTHGameData> {
    public reels: string[][];
    public reelsData: ISymbolData[][];
    public reelsFillUpData: ISymbolData[][];
    public reelDataForAS: ISymbolData[][];
    // public evaluatedArea: string[][];
    public evaluatedReels: string[][];
    public mode: string;
    public nextMode: string;
    public wasFeatureBuy: boolean;
    public freespinsLeft: number;
    public brokeTheBank: boolean;
    public accumulatedRoundWin: number;
    public avalancheRoundWin: number;
    public winRatio: number;
    public currentWinRatio: number;
    public allWinPositions: boolean[][];
    public allWinPositionSymbols: string[][];
    public xWaysSymbol: string | undefined;
    public xWaysSizes: number[][];
    public spinWin: number; // adds up every avalanche ' win
    public win: number;
    public xWaysSymbolPositions: number[][];
    public xSplitSymbolPositions: number[][];
    public xNudgeSymbolPositions: number[][];
    public removalSymbolPositions: number[][];
    public consecutiveAvalanches: number;
    public nearWinReels: boolean[];
    public numberOfScattersOnReel: number[];
    public postSafeArea: string[][];
    public scatterCoordinatesPerReel: { reelId: number, symId: number }[][] = [];
    public isGodModeMaxWin: boolean;
    public maxWinSymbolPosition: number[];
    public bigWinType: IBigWinLevel[];
    public xNudgePositionPerReel: number[][];
    public potentialWinPosition: number[][][];
    public scatterCountFS: number;
    public safeSymbols: { x: number, y: number }[];
    public extraSpinCost: number = 0;
    private _isRestoreFeatureBet: boolean;

    constructor(api: ApiPlugin, triggerEvents: boolean = true) {
        super(api, triggerEvents);

        api.events.once("featureBet", (data: boolean) => {
            this._isRestoreFeatureBet = data;
        });
        api.events.once("featureName", (data: string) => {
            this._buyFeatureName = data;
        });
        HTH.apiPlugin.events.on(APIEvent.BET, (betData: APIFeatureBetEventData) => {

            for (let index = 0; index < HTH.model.initData.featureBuyTimesBetValue.length; index++) {
                if (HTH.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this._buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this._buyFeatureName);
                    break;
                }
            }
        });

        HTH.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData: APIFeatureBetEventData) => {
            for (let index = 0; index < HTH.model.initData.featureBuyTimesBetValue.length; index++) {
                if (HTH.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this._buyFeatureName = betData.featureName;
                    break;
                }
            }
        });

    }

    private _buyFeatureName: string;

    public get buyFeatureName(): string {
        return this._buyFeatureName;
    }

    private _isRestore: boolean = false;

    public get isRestore(): boolean {
        return this._isRestore;
    }

    private _isBigWin: boolean;

    public get isBigWin(): boolean {
        return this._isBigWin;
    }

    public get isLuckyDraw(): boolean {
        return this._buyFeatureName === "LUCKY_DRAW";
    }

    public get isNormal(): boolean {
        return this.mode === HTHGameMode.NORMAL;
    }

    public get isNextNormal(): boolean {
        return this.nextMode === HTHGameMode.NORMAL;
    }

    public get isNextAvalanche(): boolean {
        return this.nextMode.indexOf("AVALANCHE") > -1;
    }

    public get isExtraSpinEndingAuto(): boolean {
        return (HTH.model.data.mode.includes("FREESPIN") && HTH.model.data.isExtraSpin && (HTH.model.data.nextMode === HTHGameMode.NORMAL));
    }

    public get isNextExtraSpinYes(): boolean {
        return (HTH.model.data.mode.includes("FREESPIN") && HTH.model.data.isExtraSpin && (HTH.model.data.nextMode === HTHGameMode.EXTRA_SPIN));
    }

    public get isNextExtraSpinNo(): boolean {
        return HTH.model.data.mode === HTHGameMode.EXTRA_SPIN && HTH.model.data.nextMode === HTHGameMode.NORMAL
    }

    public get isFreespin(): boolean {
        return this.mode.indexOf("FREESPIN") > -1;
    }

    public get isCurrentAvalanche(): boolean {
        return this.mode.indexOf("AVALANCHE") > -1;
    }

    public get isXWaysPresent(): boolean {
        return this.xWaysSymbolPositions.length > 0;
    }

    public get isXSplitPresent(): boolean {
        return this.xSplitSymbolPositions.length > 0;
    }

    public get isScatterPresent(): boolean {
        return this.scatterCoordinatesPerReel.length > 0;
    }

    public get isXNudgePresent(): boolean {
        return this.xNudgeSymbolPositions.length > 0;
    }

    public get isRemovalSymbolPresent(): boolean {
        return this.removalSymbolPositions.length > 0;
    }

    public onGame(data: IHTHGameData): void {
        super.onGame(data);
        this._isRestore = false;
        this.mode = data.mode;
        this.nextMode = data.nextMode;
        this.reels = data.reels;
        this.xWaysSymbolPositions = [];
        this.xSplitSymbolPositions = [];
        this.removalSymbolPositions = [];
        this.xNudgeSymbolPositions = [];
        this.maxWinSymbolPosition = [];
        this.isGodModeMaxWin = false;
        this.wasFeatureBuy = data.wasFeatureBuy;
        this.freespinsLeft = data.freespinsLeft;
        this.postSafeArea = data.postSafeArea;
        this.scatterCountFS = data.scatterCountFS;
        if (this.isRestore) {
            this.xNudgePositionPerReel = [[], [], [], [], [], []];
        }
        this.reelsData = this.parseReelData(this.reels, this.getGameAreaSize(this.reels), false);
        this.reelsFillUpData = this.parseFillUpReelData(data.reels, data.sizes, this.getGameAreaSize(data.reels));
        // this.reelsFillUpData = this.parseFillUpReelData(data.reelsAfterCollapse, this.getGameAreaSize(data.reelsAfterCollapse));
        this.reelDataForAS = this.parseASReelData(data.reelsAfterAvalanche, data.sizesAfterAvalanche, this.getGameAreaSize(data.reels))
        this.brokeTheBank = data.brokeTheBank;
        this.accumulatedRoundWin = data.accumulatedRoundWin;
        this.avalancheRoundWin = data.spinWin;
        // this.evaluatedArea = data.evaluatedArea;
        this.evaluatedReels = data.evaluatedReels;
        this.spinWin = data.spinWin;
        this.winRatio = MathHelper.roundToDecimals((this.isFreespin ? data.spinWin : data.accumulatedRoundWin) / data.playedBetValue, 1);
        this.currentWinRatio = MathHelper.roundToDecimals(data.win / data.playedBetValue, 1);
        // this.allWinPositions = this.parseAllWinPositions(data.evaluatedArea, data.betWayWins);
        this.allWinPositions = this.parseAllWinPositions(data.evaluatedReels, data.betWayWins);
        this.xWaysSymbol = data.xWaysSymbol ? data.xWaysSymbol : undefined;
        this.xWaysSizes = data.xWaysSizes;
        this.bigWinType = this.getBigWinType();
        this.isGodModeMaxWin = HTH.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "GOD_MODE" && this.isMaxWinInGodMode(this.reels);
        this._isBigWin = HTHHelper.isBigWin(this.isFreespin ? data.spinWin : data.accumulatedRoundWin, this.gameData?.playedBetValue);
        this.consecutiveAvalanches = data.consecutiveAvalanches;
        this.potentialWinPosition = this.isXWaysPresent ? this.getPotentialWinPos(this.reels) : [];
        this.scatterCoordinatesPerReel = this.getScatterPositionOnReels(data.reels);
        if (!this.isRestore) {
            this.numberOfScattersOnReel = this.isNormal ? this.parseScatterNumberOnReels(data.reels) : HTHGameConfig.scatterNumOnReels;
            this.nearWinReels = this.parseNearWin(!this.isFreespin);
        }
        this.safeSymbols = data.safeSymbols;
        if (this.data.isExtraSpin && this.data.extraSpinCost) {
            if (this.data.extraSpinCost > 0) {
                this.extraSpinCost = this.data.extraSpinCost;
            }
        }
    }

    protected onInit(data: IHTHInitData): void {
        super.onInit(data);
        this._isRestore = data.isRestoreState;
        this.mode = data.mode;
        this.nextMode = data.nextMode;
        this.reels = data.reels;
        this.xWaysSymbolPositions = [];
        this.xSplitSymbolPositions = [];
        this.xNudgeSymbolPositions = [];
        this.removalSymbolPositions = [];
        this.maxWinSymbolPosition = [];
        this.isGodModeMaxWin = false;
        this.bigWinType = this.getBigWinType();
        this.xNudgePositionPerReel = [[], [], [], [], [], []];
        this.reelsData = this.parseReelData(this.reels, this.getGameAreaSize(this.reels), true);
        this.reelsFillUpData = this.parseFillUpReelData(data.reels, data.sizes, this.getGameAreaSize(data.reels));

        // this.reelsFillUpData = this.parseFillUpReelData(data.reelsAfterCollapse, this.getGameAreaSize(data.reelsAfterCollapse));
        this.wasFeatureBuy = data.wasFeatureBuy;
        this.freespinsLeft = data.freespinsLeft;
        this.brokeTheBank = false;
        this.scatterCountFS = data.scatterCountFS;
        this.isGodModeMaxWin = HTH.apiPlugin.betFeatureController.getActiveBetFeature()?.name === "GOD_MODE" && this.isMaxWinInGodMode(this.reels);
        this._isBigWin = false;
        this.consecutiveAvalanches = data.consecutiveAvalanches;
        this.scatterCoordinatesPerReel = this.getScatterPositionOnReels(data.reels);
        this.numberOfScattersOnReel = this.parseScatterNumberOnReels(data.reels);
        this.safeSymbols = data.safeSymbols;
        this.extraSpinCost = 0;
    }

    private parseReelData(reels: string[][], reelSizes: number[], isInit: boolean): ISymbolData[][] {
        const reelsData: ISymbolData[][] = [];
        reels.forEach((reel: string[], i: number) => {
            const reelData: ISymbolData[] = [],
                symSize: number = 1;
            reel.forEach((symName: string, j: number) => {
                reelData.push({
                    symName: (this.xNudgePositionPerReel[i]?.length > 0 && this.xNudgePositionPerReel[i][1] !== j && symName === "XN") ? "BL" : symName,
                    symSize: symSize,
                    id: j,
                    reelId: i,
                    spinPosition: 0
                });
                if (!isInit) {
                    if (symName === "SA") {
                        symName = this.postSafeArea[i][j];
                        // symName = HTH.model.gameData.evaluatedReels[i][j];
                    }
                }
                if (symName === "XW") {
                    this.xWaysSymbolPositions.push([i, j]);
                }
                if (symName === "XS") {
                    this.xSplitSymbolPositions.push([i, j]);
                }
                if (symName === "RW") {
                    this.removalSymbolPositions.push([i, j]);
                }
                if (symName === "XN") {
                    if ((i == 1 && j == 3 && HTH.model.data.enhancerBlocks[0] !== "XN") || (i == 2 && j == 3 && HTH.model.data.enhancerBlocks[1] !== "XN") || (i == 3 && j == 3 && HTH.model.data.enhancerBlocks[2] !== "XN") || (i == 4 && j == 3 && HTH.model.data.enhancerBlocks[3] !== "XN")) {

                    } else {
                        if (this.xNudgePositionPerReel[i]?.length == 0) {
                            this.xNudgePositionPerReel[i].push(i);
                            this.xNudgePositionPerReel[i].push(j);
                        }
                        this.xNudgeSymbolPositions.push([i, j]);
                    }
                }
            });

            reelsData.push(reelData);
        });
        return reelsData;
    }

    private getGameAreaSize(reels: string[][]): number[] {
        let defaultSize: number[] = [4, 3, 3, 3, 3, 4];
        return defaultSize;
    }

    private parseAllWinPositions(reels: string[][], betWayWinData: IBetWayWinData[]): boolean[][] {
        const winPositions: boolean[][] = ArrayHelper.initArrayWithValues(6, () => {
            return ArrayHelper.initArrayWithValues(4, () => false);
        });
        const allWinPositionSymbols: string[][] = ArrayHelper.initArrayWithValues(6, () => {
            return ArrayHelper.initArrayWithValues(4, () => "");
        });
        let maxWinReelId: number = -1;
        betWayWinData.forEach((betWayWin: IBetWayWinData) => {
            const winSym: string = betWayWin.symbol;
            maxWinReelId = Math.max(maxWinReelId, betWayWin.length);
            let reelWinPositions: boolean[][] = ArrayHelper.initArrayWithValues(6, () => {
                return ArrayHelper.initArrayWithValues(4, () => false);
            });

            reels.forEach((reel: string[], i: number) => {
                if (i <= betWayWin.length) {
                    reel.forEach((symName: string, j: number) => {
                        if (symName === winSym || this.isWildTypeSymbol(symName)) {
                            winPositions[i][j] = true;
                            allWinPositionSymbols[i][j] = symName;
                            reelWinPositions[i][j] = true;
                        }
                    });
                }
            });
            betWayWin.reelWinPositions = reelWinPositions;
        });
        this.allWinPositionSymbols = allWinPositionSymbols;
        return winPositions;
    }

    private getPotentialWinPos(reelsData: string[][]): number[][][] {

        let data: string[][] = [];

        for (let i = 0; i < 6; i++) {
            let reel = [];
            for (let j = 0; j < 4; j++) {
                let symbol = reelsData[i][j];
                if (symbol === "SA") {
                    symbol = HTH.model.gameData.postSafeArea[i][j];
                }

                reel.push(symbol);
            }
            data.push(reel);
        }


        let potentialSym: string[] = [], endPos: number[] = [],
            firstXWOnReel: number = this.xWaysSymbolPositions[0][0],
            lines: number[][][] = [];

        for (let i = 0; i < 6; i++) {
            for (let j = 0; j < 4; j++) {
                let symName: string = data[i][j];
                if (!this.isSymbolWildType(symName) && potentialSym.indexOf(symName) < 0 && symName !== "SC" && symName !== "SA" && symName !== "EB") {
                    potentialSym.push(symName);
                    endPos.push(i);
                }

            }
            if (!this.reelContainsWildType(data[i])) {
                break;
            }
        }

        for (let i: number = 0; i < 6; i++) {
            let m: number = potentialSym.length - 1;

            while (m > -1) {
                const hasPotentialSym: boolean = data[i].indexOf(potentialSym[m]) > -1;
                if ((hasPotentialSym || this.reelContainsWildType(data[i])) && (endPos[m] === (i - 1))) {
                    endPos[m]++;
                } else if (i >= 2 && endPos[m] < 2) {
                    potentialSym.splice(m, 1);
                    endPos.splice(m, 1);
                }
                m--;
            }
        }
        let n: number = endPos.length - 1;
        while (n > -1) {
            if (endPos[n] < firstXWOnReel) {
                potentialSym.splice(n, 1);
                endPos.splice(n, 1);
            }
            n--;
        }

        if (potentialSym.length === 0) {
            return lines;
        }


        lines = ArrayHelper.initArrayWithValues(potentialSym.length, () => []);
        potentialSym.forEach((potentialSymName: string, symId: number) => {
            for (let s: number = 0; s <= endPos[symId]; s++) {
                data[s].forEach((symbol: string, t: number) => {
                    if ((symbol === potentialSymName || this.isSymbolWildType(symbol))) {
                        lines[symId].push([s, t]);
                    }
                });
            }
        });
        return lines;
    }

    private isSymbolWildType(sym: string): boolean {
        if (sym === "W" || sym === "XW" || sym === "XS" || sym === "XN") {
            return true;
        }
        return false;
    }

    private reelContainsWildType(reel: string[]): boolean {
        if (reel.includes("W") || reel.includes("XW") || reel.includes("XS") || reel.includes("XN")) {
            return true;
        }
        return false;
    }

    private isWildTypeSymbol(symName: string): boolean {
        if (symName === "W" || symName === "XN" || symName === "XS") {
            return true;
        }
        return false;
    }

    // private parseFillUpReelData(reelsData: string[][], reelSizes: number[]): ISymbolData[][] {
    private parseFillUpReelData(reelsData: string[][], symbolSizes: number[][], reelSizes: number[]): ISymbolData[][] {
        const newReelsData: ISymbolData[][] = [];
        reelsData.forEach((reelData: string[], i: number) => {
            const newReelData: ISymbolData[] = [];
            let xnCount: number = 0;
            reelData.forEach((data: string, j: number) => {
                let isMatched: boolean = false;
                let multiInCaseOfXnSA: number = 0
                this.data.safeSymbols.forEach((value: { x: number, y: number }) => {
                    if (i === value.x && j === value.y) {
                        isMatched = true;
                    }
                })
                if (this.isRestore && Object.keys(this.data.safeSizesBehindXNudge).length > 0) {
                    this.data.safeSizesBehindXNudge.forEach((value: [{ x: number, y: number }, number]) => {
                        if (i === value[0].x && j === value[0].y) {
                            multiInCaseOfXnSA = value[1];
                        }
                    })
                }

                newReelData.push({
                    symName: isMatched ? "SA" : (this.xNudgePositionPerReel[i]?.length > 0 && this.xNudgePositionPerReel[i][1] !== j && data === "XN") ? "BL" : data,
                    // symSize: symSize,
                    symSize: multiInCaseOfXnSA > 0 ? multiInCaseOfXnSA : symbolSizes[i][j],
                    id: j,
                    reelId: i,
                    spinPosition: 0
                });
                if (data === "XN") {
                    if (this.xNudgePositionPerReel[i]?.length == 0) {
                        this.xNudgePositionPerReel[i].push(i);
                        this.xNudgePositionPerReel[i].push(j);
                    }
                    xnCount++;
                }
            });
            newReelsData.push(newReelData);
        });
        return newReelsData;
    }

    private parseASReelData(reelsData: string[][], symbolSizes: number[][], reelSizes: number[]): ISymbolData[][] {
        const newReelsData: ISymbolData[][] = [];
        reelsData.forEach((reelData: string[], i: number) => {
            const newReelData: ISymbolData[] = [];
            let xnCount: number = 0;
            reelData.forEach((data: string, j: number) => {
                let isMatched: boolean = false;
                HTH.model.data.safeSymbols.forEach((value: { x: number, y: number }) => {
                    if (i === value.x && j === value.y) {
                        isMatched = true;
                    }
                })

                newReelData.push({
                    symName: isMatched ? "SA" : (this.xNudgePositionPerReel[i]?.length > 0 && this.xNudgePositionPerReel[i][1] !== j && HTH.model.data.reels[i][j] === "XN") ? "BL" : (data === "XN") ? HTH.model.data.reels[i][j] : data,
                    symSize: symbolSizes[i][j],
                    id: j,
                    reelId: i,
                    spinPosition: 0
                });
                if (data === "XN" && HTH.model.data.reels[i][j] === "XN") {
                    //Taking reels in reference because a case can happen where XN has just landed and ReelsAfterAva will show XN in whole reel, but reels will show only at 1 position
                    if (this.xNudgePositionPerReel[i]?.length == 0) {
                        this.xNudgePositionPerReel[i].push(i);
                        this.xNudgePositionPerReel[i].push(j);
                    }
                    xnCount++;
                }
            });
            newReelsData.push(newReelData);
        });
        return newReelsData;
    }

    private isMaxWinInGodMode(reels: string[][]): boolean {
        for (let i = 0; i < reels.length; i++) {
            for (let j = 0; j < reels[i].length; j++) {
                if (reels[i][j] === "MAX") {
                    this.maxWinSymbolPosition = [i, j];
                    return true;
                }
            }
        }
        return false;
    }

    private parseScatterNumberOnReels(reels: string[][]): number[] {
        const scatterNumberOnReels: number[] = [];
        reels.forEach((syms: string[], i: number) => {
            let numberOfScatter: number = 0;

            syms.forEach((sym: string) => {
                numberOfScatter += (sym === "SC" || sym === "SA" ? 1 : 0);
            });
            scatterNumberOnReels.push(numberOfScatter);
        });
        HTHGameConfig.scatterNumOnReels = scatterNumberOnReels;

        return scatterNumberOnReels;
    }

    private getScatterPositionOnReels(reels: string[][]): { reelId: number, symId: number }[][] {
        const arr: { reelId: number, symId: number }[][] = [];

        reels.forEach((reel: string[], i: number) => {
            const reelArr: { reelId: number, symId: number }[] = [];
            reel.forEach((sym: string, j) => {
                if (sym === "SC") {
                    reelArr.push({reelId: i, symId: j});
                }
            })
            if (reelArr.length > 0) {
                arr.push(reelArr);
            }
        })

        return arr;
    }

    private parseNearWinOnRestore(prevScatters: number[], wasFeatureBuy: boolean): boolean[] {
        const nearWinReels: boolean[] = ArrayHelper.initArrayWithValues(6, () => false);
        if (!this._isRestore) {
            return nearWinReels;
        }
        if (!this.isNextAvalanche) {
            return nearWinReels;
        }

        if (this.isLuckyDraw || wasFeatureBuy) {
            return nearWinReels;
        }

        if (HTHHelper.sum(prevScatters) >= 2) {
            this.reels.forEach((syms: string[], i: number) => {
                if (prevScatters[i] >= 2) {
                    nearWinReels[i] = false;
                } else {
                    nearWinReels[i] = syms.indexOf("X") > -1;
                }
            });
        }

        return nearWinReels;
    }

    private getBigWinType(): IBigWinLevel[] {
        const selectedFeatureBet = HTH.apiPlugin.betFeatureController.getActiveBetFeature()?.name;

        if (selectedFeatureBet === "GOD_MODE") {
            return HTHWinConfig.BIG_WIN_RATIOS.bigWinGodMode;
        } else if (selectedFeatureBet) {
            return HTHWinConfig.BIG_WIN_RATIOS.bigWinBonusBuy;
        } else if (this.mode.includes("FREESPIN") || this.nextMode.includes("FREESPIN")) {
            return HTHWinConfig.BIG_WIN_RATIOS.bigWinFreeSpin;
        }
        return HTHWinConfig.BIG_WIN_RATIOS.bigWinBaseGame;

    }

    private parseNearWin(isBaseGame: boolean): boolean[] {
        const nearWinReels: boolean[] = ArrayHelper.initArrayWithValues(6, () => false);
        if (!isBaseGame) {
            return nearWinReels;
        }


        /* if (this.isLuckyDraw) {
             newScatters.forEach((num: number, i: number) => {
                 nearWinReels[i] = (totalScatterNum >= 3);
                 totalScatterNum += num;
             });
             return nearWinReels;
         }
 */
        if (this.wasFeatureBuy && !this.isLuckyDraw) {
            return nearWinReels;
        }

        if (this.wasFeatureBuy && this.isLuckyDraw) {
            const anticipationReels: boolean[] = [true, true, true, true, true, true];
            let scatterNo: number = 0;
            this.reels.forEach((symArray: string[], reelId: number) => {
                if (scatterNo === 3) {
                    anticipationReels[reelId] = false;
                }
                symArray.forEach((sym: string, symId: number) => {
                    if (sym === "SA" || sym === "SC") {
                        scatterNo++;
                    }
                });
            });


            return anticipationReels;
        }

        let totalScatterNum: number = 0,
            toAnticipate: boolean = totalScatterNum >= 2;

        if (this.isNormal) {
            this.reels.forEach((syms: string[], reelId: number) => {
                syms.forEach((sym: string, index: number) => {
                    if (sym === "SA" || sym === "SC") {
                        totalScatterNum++;
                    }
                    if (totalScatterNum > 1 && ((reelId + 1) < this.reels.length) && totalScatterNum < 3) {
                        nearWinReels[reelId + 1] = true;
                    } else {
                        if ((reelId + 1) < this.reels.length) {
                            nearWinReels[reelId + 1] = false;
                        }
                    }
                });
            });
        } else {
            let oldCount = HTHHelper.sum(this.numberOfScattersOnReel);
            let newSymsArray: string[][] = JSON.parse(JSON.stringify(this.reels));
            HTH.reelArea.allReels.forEach((reelModel: HTHAvalancheReelModel, index: number) => {
                let collapsedSymArray: HTHSymbol[] = reelModel.reelView.getAllSymbols();
                collapsedSymArray.forEach((sym: HTHSymbol) => {
                    newSymsArray[index][sym.id] = "X";
                })
                let newSymsInReel: string[] = [];
                newSymsArray[index].forEach((symName: string) => {
                    if (symName !== "X") {
                        newSymsInReel.push(symName);
                    }
                });
                newSymsArray[index] = newSymsInReel;
            });

            this.numberOfScattersOnReel = this.parseScatterNumberOnReels(this.reels);

            if (oldCount === 2) {
                nearWinReels[0] = true;
            }

            newSymsArray.forEach((syms: string[], reelId: number) => {
                syms.forEach((sym: string, index: number) => {
                    if (sym === "SA" || sym === "SC") {
                        oldCount++;
                    }
                });
                if (oldCount > 1 && ((reelId + 1) < this.reels.length && newSymsArray[reelId + 1].length > 0) && oldCount < 3) {
                    nearWinReels[reelId + 1] = true;
                } else if (oldCount < 2 && ((reelId + 1) < this.reels.length && newSymsArray[reelId + 1].length > 0)) {
                    nearWinReels[reelId + 1] = false;
                }
            });

        }
        /* if (toAnticipate) {
         } else {
             //debugger;
             newScatters.forEach((num: number, i: number) => {
                 totalScatterNum += (num - prevScatters[i]);
                 nearWinReels[i] = toAnticipate;
                 toAnticipate = (totalScatterNum >= 2);
             });
         }*/
        return nearWinReels;
    }

}